import bem from 'utils/bem';

export const editAutomationSelectHeaderBlock = bem(
  'edit-automation-select-header',
);
